import * as React from "react";
export default class SupplierDesc extends React.Component {
    constructor(props) {
        super(props);
        this.goToAgentWebsite = () => {
            let website = this.props.agents.Website;
            if (website.indexOf('http://') != 0 && website.indexOf('https://') != 0) {
                website = 'http://' + website;
            }
            location.href = website;
        };
    }
    toTitleCase(str) {
        return str == null ? str : str.replace(/([^\W_]+[^\s-]*) */g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }
    capitalizeDirection(str) {
        if (str == null) {
            return str;
        }
        const directions = [' Ne', ' Nw', ' Sw', ' Se'];
        let retVal = str;
        for (let i = 0; i < directions.length; i++) {
            retVal = retVal.replace(directions[i], directions[i].toUpperCase());
        }
        return retVal;
    }
    render() {
        const { agents } = this.props;
        return (React.createElement("div", { className: "supplier-desc" },
            React.createElement("div", { className: "section first" },
                React.createElement("div", null,
                    React.createElement("span", null, "ADDRESS"),
                    React.createElement("span", null,
                        this.capitalizeDirection(this.toTitleCase(agents.Address)),
                        " ",
                        React.createElement("br", null),
                        this.toTitleCase(agents.City),
                        ", ",
                        agents.Province.toUpperCase(),
                        " ",
                        React.createElement("br", null),
                        agents.PostalCode.toUpperCase())),
                React.createElement("div", null,
                    React.createElement("span", null, "AGENT URL"),
                    React.createElement("span", null,
                        React.createElement("a", { href: "#", onClick: this.goToAgentWebsite }, agents.Website)))),
            React.createElement("div", { className: "section second" },
                React.createElement("div", null,
                    React.createElement("span", null, "PHONE"),
                    React.createElement("span", null, agents.PhoneNumber)),
                React.createElement("div", null,
                    React.createElement("span", null, "FAX"),
                    React.createElement("span", null, agents.Fax)),
                React.createElement("div", null,
                    React.createElement("span", null, "KEY SALES CONTACT"),
                    React.createElement("span", null, this.toTitleCase(agents.KeySalesContact))),
                React.createElement("div", null,
                    React.createElement("span", null, "SOCIAL MEDIA"),
                    React.createElement("span", null,
                        agents.Facebook ? React.createElement("a", { href: agents.Facebook },
                            React.createElement("i", { className: "fa fa-facebook-official" })) : null,
                        agents.Twitter ? React.createElement("a", { href: agents.Twitter },
                            React.createElement("i", { className: "fa fa-twitter-square" })) : null,
                        agents.Instagram ? React.createElement("a", { href: agents.Instagram },
                            React.createElement("i", { className: "fa fa-instagram" })) : null))),
            React.createElement("div", { className: "section third" },
                React.createElement("div", null,
                    React.createElement("p", null, "CATEGORIES/SPECIALTY"),
                    React.createElement("p", null, agents.Specialty)))));
    }
}
;
//# sourceMappingURL=desc.js.map